export const createPrefixer =
  (str = '') =>
  (val: TemplateStringsArray) =>
    `${str}${val}`;
